// extracted by mini-css-extract-plugin
module.exports = {"container":"FeatureToggleBadge_container__2JKjx","label":"FeatureToggleBadge_label__OF7B-","active":"FeatureToggleBadge_active__PKg_x"};